import Roles from '@/auth/roles';
import i18n from '@/lang' // Internationalization
import clubModel from '@/entities/club/club-model';
import historyFullStore from './team-history/team-history-full/team-history-full-store';
import historySingleStore from './team-history/team-history-single/team-history-single-store';
import teamModel from './team-model';
import teamPager from './team-pager';
import service from './team-service';
import categoryService from '../category/category-service';
import clubService from '../club/club-service';
// import playerService from '../player/player-service';
 /* eslint-disable */
export default {
  namespaced: true,

  modules: {
    historyFull: historyFullStore,
    historySingle: historySingleStore
  },

  state: {
    loading: false,
    list: [],
    pager: teamPager.build(),
    model: teamModel.default(),
    options: {},
  },

  getters: {
    loading: state => state.loading,
    list: state => state.list,
    pager: (state) => state.pager,
    model: state => state.model,
    options: state => state.options,
    hasRoleToUpdate: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.entityEditor.id,
        roles.teamEditor.id
      ]);
    },
    hasRoleToCreate: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.entityEditor.id,
        roles.teamEditor.id
      ]);
    },
    hasRoleToRead: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.teamViewer.id,
        roles.teamEditor.id
    ]);
    },
    hasRoleToReadLogs: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.activityViewer.id
      ]);
    },
    hasRoleToDelete: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.entityEditor.id,
        roles.teamEditor.id
      ]);
    }
  },

  mutations: {
    LOADING(state, payload) {
      state.loading = !!payload;
    },

    LIST(state, payload) {
      state.list = payload || [];
    },

    MODEL(state, payload) {
      state.model = payload || teamModel.default();
    },

    CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = teamPager.build();
      state.model = teamModel.default();
      state.options = {};
    },

    ADD_OPTIONS(state, payload) {
      state.options = Object.assign({}, state.options, { [payload.key]: payload.options });
    },
  },

  actions: {
    detail({ commit, dispatch }, id) {
      commit('LOADING', true);
     
      return service
        .find(id).then((model) => {
          
          if (!model || !model.id) {
            return Promise.reject(new Error('Not found'));
          }

          commit('MODEL', model);
          commit('LOADING', false);
          return Promise.resolve();
      })
    },

    new({  commit, dispatch, rootGetters  }) {
      const club = rootGetters['entities/club/model']
      
      var model = { club:  club}
      
      commit('MODEL', model);
    },

    edit({ commit, dispatch }, id) {
      commit('LOADING', true);
     
      return service.find(id).then((model) => {
          if (!model || !model.id) {
            return Promise.reject(new Error('Not found'));
          }

          commit('MODEL', model);
          commit('LOADING', false);
          return Promise.resolve();
        })
    },

    save({ getters, commit, rootGetters, dispatch }, team) {
      commit('LOADING', true);
      var modelToSave = getters.model

      if (team !== null ) {
        modelToSave = team
      } 
      return service
        .save(modelToSave, rootGetters['auth/user'])
        .then(() => {
          dispatch(
            'shared/success',
            `${i18n.t('entities.team.singular')} ${i18n.t('notification.savedSuccessfully')}`,
            { root: true }
          );

          commit('LOADING', false);
        })
      
    },

    destroy({ commit, dispatch, rootGetters }, model) {
      commit('LOADING', true);

      const club = rootGetters['entities/club/model']
      var modelToDestroy = model
      if (club.id !== null) {
        modelToDestroy = { ...model, club:  clubModel.forSimple(club)}
      }
            
      return service
        .destroy(modelToDestroy, rootGetters['auth/user'])
        .then(() => {
          dispatch(
            'shared/success',
            `${i18n.t('entities.team.singular')} ${i18n.t('notification.deletedSuccessfully')}`,
            { root: true }
          );
        })
        .catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
    },

    list({ commit, dispatch }) {
      commit('LIST', []);
      commit('LOADING', true);
      
      return service
        .list()
        .then((list) => {
          commit('LIST', list);
          commit('LOADING', false);
        })
        .catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
    },

    importPlayersSetup({ commit, dispatch, rootGetters }, team) {
      const club = rootGetters['entities/club/model']
      var modelToSetup = team

      if (club.id !== null) {
        modelToSetup = { ...team, club:  clubModel.forSimple(club)}
      }

      return Promise.resolve(modelToSetup)
    },

    exportAsPDF({ commit, dispatch, rootGetters }, team) {
      commit('LOADING', true);

      const club = rootGetters['entities/club/model']
      var modelToExport = team

      if (club.id !== null) {
        modelToExport = { ...team, club:  clubModel.forSimple(club)}
      }

      return service
        .exportAsPDF(modelToExport)
        .then(() => {
          commit('LOADING', false);
        })
        .catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
    },

    listByClubId({ commit, dispatch }, clubId) {
      commit('LIST', []);
      commit('LOADING', true);
      
      return service
        .listByClubId(clubId)
        .then((list) => {
          commit('LIST', list);
          commit('LOADING', false);
        })
        .catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
    },

    clear({ commit }) {
      commit('CLEAR');
    },

    loadOptions({ commit, dispatch }) {
      categoryService.listOptions().then((options) => {
        commit('ADD_OPTIONS', { key: 'categories', options });
      }).catch((error) => {
        dispatch('shared/error', error, { root: true });
        return Promise.reject(error);
      });
      clubService.listOptions().then((options) => {
        commit('ADD_OPTIONS', { key: 'clubs', options });
      }).catch((error) => {
        dispatch('shared/error', error, { root: true });
        return Promise.reject(error);
      });
      // playerService.listOptions().then((options) => {
      //   commit('ADD_OPTIONS', { key: 'players', options });
      // }).catch((error) => {
      //   dispatch('shared/error', error, { root: true });
      //   return Promise.reject(error);
      // });
    },
  },
};



// WEBPACK FOOTER //
// ./src/entities/team/team-store.js